import React, { useState } from 'react'
import { RightOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { images } from "../../assests/imageExport/ImageExports";
import EmailIcon from "../../assests/images/home/Mail.svg";
import PhoneIcon from "../../assests/images/home/Phone2.svg";
import SociaMedia from "../../assests/images/home/Facebook.svg";
import SociaMedia2 from "../../assests/images/home/Instagram.svg";
import SociaMedia3 from "../../assests/images/home/Twitter.svg";
import SociaMedia4 from "../../assests/images/home/Linkedin.svg";
import { useAuth } from '../../user/context/AuthContext';
import useCustomSnackbar from '../../helper/useCustomSnackbar';
import usePost from '../../services/usePost'

const Footer = () => {
  const navigate = useNavigate();
  const { confirmLogout, token,isAuthenticated } = useAuth();
  const [gmail,setGmail] = useState(null)
  const showSnackbar = useCustomSnackbar()
  const [postLoading, errorMsg, postData] = usePost();

//check for valid gmail
  const gmailCheck = () => {

    if(gmail === null){
      showSnackbar('error','Please enter your gmail') 
      return
    }
    const check = gmail.includes('gmail.com')
    
    if(!check){
      showSnackbar('error','Please enter your gmail') 
      return
    }
    return check
  }

  //api call for newsletter subscribe

  const newsLetterSubscribe = () =>{

    const dataToSend = {
      createdAt: new Date().toISOString(),
      email: gmail,
      updatedAt: new Date().toISOString()
    }

      if(gmailCheck()){
        const response = postData('newsletterSubscribers',dataToSend,true)

        if(response){
          setGmail('')
        }
      }
  }
  
  return (
    <footer className="footer-section">
      <div className="footer-container">
        {/* Main Footer */}
        <div className="footer-main">
          {/* About Section */}
          <div className="footer-about">
            <img src={images?.logo} alt="LMS Logo" className="footer-logo" />
            <p className="footer-description">
              Discover a World of Possibilities with TripNavigator Tours.
            </p>
          </div>

          {/* Newsletter + Links */}
          <div className="footer-content">
            {/* Newsletter */}
            <div className="newsletter">
              <h3 className="newsletter-title">Subscribe to Newsletter</h3>
              <div className="newsletter-form">
                <div className="form-container">
                  <input
                    type="email"
                    placeholder="Your email"
                    className="email-input"
                    value={gmail}
                    onChange={(e) => setGmail(e.target.value)}
                  />
                  <button className="subscribe-button" onClick={newsLetterSubscribe}>Subscribe</button>
                </div>
              </div>
            </div>

            {/* Footer Links */}
            <div className="footer-links">
              {/* Resources */}
              <div className="footer-column">
                <h3 className="column-title">Resources</h3>
                <div className="column-links">
                  <a onClick={() => navigate('/user/my-courses')} className="footer-link cursor-pointer">My Courses</a>
                  <a onClick={() => navigate('/courses')} className="footer-link cursor-pointer">Courses</a>
                  <a onClick={() => navigate('/contact')} className="footer-link cursor-pointer">Contact Us</a>
                </div>
              </div>

              {/* Legal */}
              <div className="footer-column">
                <h3 className="column-title">Legal</h3>
                <div className="column-links">
                  <a onClick={() => navigate('/terms_and_conditions')} className="footer-link cursor-pointer">Terms of Service</a>
                  <a onClick={() => navigate('/privacy_policy')} className="footer-link cursor-pointer">Privacy Policy</a>
                  {isAuthenticated() ? 
                   <a onClick={confirmLogout} className="footer-link cursor-pointer">Logout</a>
                   :
                   <a onClick={() => navigate('/login')} className="footer-link cursor-pointer">Login</a>
                  }
                </div>
              </div>

              {/* Contact & Social */}
              <div className="footer-column">
                <h3 className="column-title">Contact</h3>
                <div className="column-links">
                  <p className="contact-info">+91-9199569685</p>
                  <p className="contact-info">A:</p>
                </div>
                <div className="social-box">
                  <div className="social-icons">
                    <img src={SociaMedia} alt="Social Media 1" className="social-image" />
                  </div>
                  <div className="social-icons2">
                    <img src={SociaMedia2} alt="Social Media 2" className="social-image" />
                  </div>
                  <div className="social-icons3">
                    <img src={SociaMedia3} alt="Social Media 3" className="social-image" />
                  </div>
                  <div className="social-icons4">
                    <img src={SociaMedia4} alt="Social Media 4" className="social-image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-container">
            <div className="copyright">
              <p className="copyright-text">
                &#169; LMS 2025. All rights reserved.
              </p>
            </div>
            <div className="contact-details">
              <div className="contact-item">
                <img src={EmailIcon} alt="Email Icon" className="contact-icon" />
                <p className="contact-text">info@lms.com</p>
              </div>
              <div className="contact-item">
                <img src={PhoneIcon} alt="Phone Icon" className="contact-icon" />
                <p className="contact-text">+91-9199569685</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

  )
}

export default Footer
